<template>
  <div class="calico-form">
    <Field
      v-slot="{ field, errors }"
      :name="name"
      :label="label"
      :rules="rules"
    >
      <label
        v-if="(label) && rules && rules.split('|').includes('required')"
        class="label--medium"
      >
        *{{ label }}
        <CalicoTooltip
          v-if="tooltip.body"
          :header="tooltip.header"
          :body="tooltip.body"
        />
      </label>
      <label
        v-else
        class="label--medium"
      >
        {{ label }}
        <CalicoTooltip
          v-if="tooltip.body"
          :header="tooltip.header"
          :body="tooltip.body"
        />
      </label>

      <div class="field">
        <slot
          :field="field"
          :error="errors && errors[0]"
        />
      </div>

      <span
        v-if="message"
        class="message body--xsmall"
      >{{ message }}</span>
      <span
        v-if="important"
        class="important body--xsmall"
      >{{ important }}</span>
      <span
        v-if="errorMessage(errors)"
        class="error body--xsmall"
      >
        <i class="bi bi-exclamation-circle-fill" />
        {{ errorMessage(errors) }}
      </span>
    </Field>
  </div>
</template>

<script>
import { Field } from "vee-validate";
import CalicoTooltip from "@/components/calico/tooltip/index.vue"

export default {
  name: "CalicoForm",
  components: {
    Field,
    CalicoTooltip
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    error: {
      type: String,
    },
    message: {
      type: String,
      default: "",
    },
    important: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object, Function],
      required: true,
    },
    tooltip: {
      type: Object,
      default: () => ({
        header: '',
        body: '',
      }),
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    errorMessage(errors) {
      return this.error !== undefined ? this.error : errors[0]
    }
  }
};
</script>

<style scoped lang="scss">
.calico-form {
  @include stack-space($space-xsmall);
  width: 100%;
  .confirmation {
    @include stack-space($space-small);
    padding-left: 10px;
    width: 100%;
  }
  .field {
    @include stack-space($space-medium);
  }
  label {
    @include inline-space($space-small);
    margin: 0;
    .bi {
      color: $color-lapis;
      font-size: $icon-small;
    }
  }
  .message {
    color: $color-text-primary;
  }
  .important {
    color: $color-lapis;
  }
  .error {
    @include inline-space($space-small);
    align-items: center;
    color: $color-text-error;
    .bi {
      line-height: 0;
      font-size: $icon-xsmall;
    }
  }
}
</style>